import * as grpcWeb from '@improbable-eng/grpc-web';

import {
	type ProfileGetPendingInvitationReply,
	ProfileGetPendingInvitationRequest
} from '@aymeric_henry_sr/svelte-proto/profile_pb';
import {
	Profile,
	type ProfileGetPendingInvitation
} from '@aymeric_henry_sr/svelte-proto/profile_pb_service';

import { GRPC_HOST } from '../../constants/env.constants';
import { Observable } from 'rxjs';
import { unaryTransport } from '../transport';
const { grpc } = grpcWeb;

export function getMyPendingInvitationList() {
	return new Observable<ProfileGetPendingInvitationReply>((obs) => {
		const req = new ProfileGetPendingInvitationRequest();
		const client = grpc.client<
			ProfileGetPendingInvitationRequest,
			ProfileGetPendingInvitationReply,
			ProfileGetPendingInvitation
		>(Profile.GetPendingInvitation, {
			host: GRPC_HOST,
			transport: unaryTransport
		});
		client.onMessage((data) => {
			obs.next(data);
		});
		client.onEnd((status) => {
			if (status === 0) {
				return obs.complete();
			}
			return obs.error();
		});
		client.start();
		client.send(req);
	});
}
